import * as Yup from "yup";

export const CharOrgsValidationSchema = Yup.object().shape({
  name: Yup.string().trim().required("Name is required"),
  email: Yup.string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
  founded: Yup.number()
    .typeError("Founded year must be a number")
    .integer("Founded year must be an integer")
    .min(1000, "Invalid year")
    .max(new Date().getFullYear(), "Founded year cannot be in the future")
    .required("Founded year is required"),
  address: Yup.string().trim().required("Address is required"),
  phone: Yup.string()
  .trim()
  .matches(
    /^(?:\+(\d{1,3})\s?)?(\(\d{3}\)\s?\d{3}-\d{4})$/,
    "Invalid phone number format. { e.g., +1 (123) 456-7890 or (123) 456-7890 }"
  )
  .required("Phone number is required"),
  website: Yup.string()
    .trim()
    .url("Invalid website URL, must be like (https://example.com)")
    .required("Website is required"),
  focusAreas: Yup.array()
    .of(Yup.string().trim().required("Focus area cannot be empty"))
    .min(1, "At least one focus area is required"),
  mission: Yup.string().trim().required("Mission statement is required"),
});
